import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const DistributorCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.DISTRIBUTORS, "uid");